import { CrossIconvector, InvoicesTabIcon } from 'assets/icons';
import { GenericModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface SendUpdateModalProps {
  showModal: boolean;
  onYesClick: VoidFn;
  onNoClick: VoidFn;
  onClose: VoidFn;
  isActionInProgress: boolean;
}

const SendUpdateModal: FC<SendUpdateModalProps> = ({
  showModal,
  onYesClick,
  onNoClick,
  onClose,
  isActionInProgress
}) => {
  return (
    <GenericModal
      showModal={showModal}
      title="Send update to customer?"
      titleStyle="text-center mb-[22px]"
      subTitleStyle="text-center text-primaryText text-sbase font-normal px-1"
      subTitle="Would you like to notify the customer that this invoice was updated?"
      primaryBtnLabel="Yes, send update"
      primaryBtnId="send-update-to-customer-yes"
      primaryBtnStyle="mt-2 h-12 mb-4"
      onPrimaryBtnClick={onYesClick}
      secondaryBtnId="send-update-to-customer-no"
      secondaryBtnLabel="Don't send"
      secondaryBtnStyle="h-12"
      onSecondaryBtnClick={onNoClick}
      closeIconStyle="top-3 right-3"
      CloseIcon={() => <CrossIconvector height={18} width={18} title="send-update-popup-close" />}
      MainIcon={({ className }: { className?: string }) => (
        <div className={`${className} flex h-[70px] w-[70px] items-center justify-center rounded-full bg-secondaryBtn`}>
          <InvoicesTabIcon className="h-8 w-8" />
        </div>
      )}
      isActionInProgress={isActionInProgress}
      onCloseIconClick={onClose}
      height="h-fit"
      className="!p-4"
    />
  );
};

export default SendUpdateModal;
